import { useMemo } from "react";

import { getQuestionnaireAnswers } from "@medplum/core";
import { QuestionnaireResponse, ServiceRequest } from "@medplum/fhirtypes";
import { TestCoding } from "@medplum/health-gorilla-core";

import { Stack } from "@mantine/core";

import { capitalize } from "lodash";

import { TextWrapper } from "@/components/TextWrapper";
import { getQuestionnaireItemAnswerValue } from "@/utils/questionnaires";

interface LabTestDetailsCardProps {
  coding: TestCoding;
  request: ServiceRequest | undefined;
  response: QuestionnaireResponse | undefined;
}

export default function LabTestDetailsCard({ coding, request, response }: LabTestDetailsCardProps) {
  const notes = request?.note?.[0]?.text;

  const answers = useMemo(() => (response ? getQuestionnaireAnswers(response) : {}), [response]);

  return (
    <Stack
      p="md"
      gap="md"
      style={{ border: "1px solid var(--mantine-color-cream-4)", borderRadius: 8 }}
    >
      <Stack gap="xs">
        <TextWrapper c="gray.6" variant="bold">
          Test
        </TextWrapper>
        <TextWrapper aria-label="Test">{coding.display}</TextWrapper>
      </Stack>
      {request?.priority && (
        <Stack gap="xs">
          <TextWrapper c="gray.6" variant="bold">
            Priority
          </TextWrapper>
          <TextWrapper aria-label="Priority">{capitalize(request.priority)}</TextWrapper>
        </Stack>
      )}
      <Stack gap="xs">
        <TextWrapper c="gray.6" variant="bold">
          Test Notes
        </TextWrapper>
        <TextWrapper aria-label="Test Notes">{notes ?? "No notes"}</TextWrapper>
      </Stack>
      {Object.keys(answers).map((key) => {
        const label = response?.item?.find((item) => item.linkId === key)?.text ?? key;
        return (
          <Stack gap="xs" key={key}>
            <TextWrapper c="gray.6" variant="bold">
              {label}
            </TextWrapper>
            <TextWrapper aria-label={label}>
              {getQuestionnaireItemAnswerValue(answers[key])}
            </TextWrapper>
          </Stack>
        );
      })}
    </Stack>
  );
}
